import './style';
import App from './components/app';

// Remove stale preact-cli service workers in local dev (they return 404 for /login, /admin, etc.)
if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
	const host = window.location.hostname;
	if (host === 'localhost' || host === '127.0.0.1') {
		navigator.serviceWorker.getRegistrations().then((regs) => {
			regs.forEach((r) => r.unregister());
		});
	}
}

export default App;
